import { Languages } from "@/src/types";
import { graphql, useStaticQuery } from "gatsby";

export type ICookieConsentData = {
  enabled: boolean;
  paragraph: string;
  label: string;
  link: {
    title: string;
    target: string;
    url: string;
  };
};

const useCookieConsentData = (lang: Languages): ICookieConsentData => {
  const { wp } = useStaticQuery(graphql`
    {
      wp {
        siteSettingsSV {
          cookie {
            cc {
              enabled
              paragraph
              label
              link {
                target
                title
                url
              }
            }
          }
        }
        siteSettingsEN {
          cookie {
            cc {
              enabled
              paragraph
              label
              link {
                target
                title
                url
              }
            }
          }
        }
        siteSettingsNO {
          cookie {
            cc {
              enabled
              paragraph
              label
              link {
                target
                title
                url
              }
            }
          }
        }
      }
    }
  `);

  return wp[`siteSettings${lang.toUpperCase()}`].cookie.cc;
};

export default useCookieConsentData;
